import type { ApolloClient } from '@apollo/client';
import { ChatNudgeOutcome, type ChatNudgeSignal } from '@insio/shared-types';
import { OfferChatNudgeDocument, RespondToChatNudgeDocument } from '@/graphql';

/** Tells the server what the user just did; resolves to the offer to show now, or null. */
export async function offerChatNudge(
  client: ApolloClient,
  signal: ChatNudgeSignal
): Promise<string | null> {
  try {
    const { data } = await client.mutate({
      mutation: OfferChatNudgeDocument,
      variables: { signal }
    });
    return data?.offerChatNudge?.nudgeId ?? null;
  } catch {
    // An offer is a courtesy — a failed ask must never surface to the user.
    return null;
  }
}

/** Records "no thanks" or "later"; best effort. */
export async function respondToChatNudge(
  client: ApolloClient,
  nudgeId: string,
  outcome: typeof ChatNudgeOutcome.DISMISSED | typeof ChatNudgeOutcome.SNOOZED
): Promise<void> {
  try {
    await client.mutate({
      mutation: RespondToChatNudgeDocument,
      variables: { nudgeId, outcome }
    });
  } catch {
    // Nothing to do — the card closes either way and the cooldown still holds the offer back.
  }
}
